import styled from 'styled-components'
import { ArrowIcon, breakpoints, colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'

const linkColor = '#0b64c4'

export const ResourcesSectionTitle = styled(Typography).attrs({
  variant: 'h3',
  variantType: 'bold',
})`
  margin-bottom: ${spacing.px16};
`

export const ResourceCardsContainer = styled.div`
  margin-top: ${spacing.px24};
  display: grid;
  grid-template-columns: auto;
  gap: ${spacing.px24};

  @media only screen and (min-width: ${breakpoints.md.min}) {
    grid-template-columns: auto auto;
  }
`

export const ResourceText = styled(Typography).attrs({
  variant: 'h6',
  variantType: 'heavy',
})`
  color: ${linkColor};
  margin-bottom: ${spacing.px16};
  :hover {
    cursor: pointer;
  }
`

export const RightArrow = styled(ArrowIcon).attrs({ pointing: 'right' })`
  color: ${linkColor};
  :hover {
    cursor: pointer;
  }
`

export const CardHeading = styled(Typography).attrs({
  variant: 'h5',
  variantType: 'bold',
})`
  color: ${colors.grey900};
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.px24};
  border-radius: ${spacing.px8};
  border: 1px solid ${colors.grey200};
  background: ${colors.grey050};
  gap: ${spacing.px8};

  @media only screen and (min-width: ${breakpoints.sm.max}) {
    gap: ${spacing.px40};
  }

  @media only screen and (min-width: ${breakpoints.md.max}) {
    gap: ${spacing.px8};
  }
`

export const ResourceSectionSubText = styled(Typography).attrs({
  variant: 'h5',
  tag: 'p',
})`
  font-size: ${font.size.px16};

  @media only screen and (min-width: ${breakpoints.lg.min}) {
    font-size: ${font.size.px22};
  }
`

export const SeeGuideText = styled(Typography).attrs({
  variant: 'subtitle',
  variantType: 'bold',
  display: 'flex',
  tag: 'a',
  tabIndex: 0,
})`
  color: ${linkColor};
  :hover {
    cursor: pointer;
  }
`
export const SeoLinks = styled.div`
  line-height: ${spacing.px16};
  height: ${spacing.px64};
  a {
    text-decoration: underline;
  }
`
